import { createFileRoute } from '@tanstack/react-router';
import { AuditPage } from '@/components/audit';

export const Route = createFileRoute('/_authenticated/audit')({
  component: AuditPage,
});
